import { FAQItem } from '../components/FAQItem';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './AIFAQSection.module.css';

const faqs = [
  {
    answer:
      "KAI is designed not to give answers. It tutors by asking leading questions, offering partial hints, and walking students through their own reasoning. Students who want to use it to short-circuit their learning will find it less useful than ChatGPT, which is what the research bears out: students using KAI actually do better in class than students who don't.",
    question: "Won't students just use KAI to cheat?",
  },
  {
    answer:
      "No. Queries are anonymized before they leave Kudu's infrastructure, and we use frontier model providers under contractual no-training agreements. We don't sell data, we don't share data, and we don't train anything on student or faculty queries. The architecture is structured so we couldn't, even if we wanted to.",
    question: 'Does Kudu train AI on student data?',
  },
  {
    answer:
      "We route to it. Institutions don't pick a model provider when they choose Kudu. Kudu holds those relationships and swaps in the best available models for each task. Your campus gets frontier capability from this year's best AI without renegotiating an AI vendor contract.",
    question: 'What happens when a better model comes out?',
  },
  {
    answer:
      "ChatGPT EDU is a general-purpose AI provided to a campus. KAI is course-specific tooling grounded in the actual textbook and configured by the faculty. ChatGPT EDU helps students do anything; KAI helps students learn the course they're taking. They are complementary tools: KAI replaces the in-course tutoring, not the school-wide AI service.",
    question: 'How is KAI different from ChatGPT EDU?',
  },
  {
    answer:
      "Yes. Faculty and student support staff can review aggregate query patterns to see what students are struggling with, what topics generate the most confusion, and where the textbook needs clarification. KAI becomes a signal about the course's friction points rather than a black box.",
    question: 'Can faculty see what students ask?',
  },
  {
    answer:
      'KAI is built to operate within FERPA-aligned data handling. Student-identifying information is not transmitted to model providers. Your IT or privacy office can write to support@kudu.com for details.',
    question: 'Is KAI FERPA-compliant?',
  },
] as const;

export function AIFAQSection() {
  return (
    <SectionWrapper background="white" data-testid="ai-section-faq">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>HARD QUESTIONS, ANSWERED</p>
          <h2 className={styles.title}>The questions we get most about KAI.</h2>
        </div>

        <div className={styles.grid}>
          {faqs.map((faq) => (
            <FAQItem key={faq.question} {...faq} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
